module.exports = __webpack_public_path__ + "img/btn.f5cb0dab.png";